'use client';

import { Locale } from '@core/Entities/Locale/Locale.entity';
import Logo from '@gds/Logo/Logo';

import { TrackedLink } from '../TrackedLink/TrackedLink';

export const LogoWrapper = ({
  baseUrl,
  logoStyle,
  locale: _,
}: {
  baseUrl: string;
  logoStyle: string;
  locale: Locale;
}) => {
  return (
    <TrackedLink
      ariaLabel="heycar logo"
      className={logoStyle}
      href={baseUrl}
      trackingObj={{ label: 'Logo', href: baseUrl }}
    >
      <Logo />
    </TrackedLink>
  );
};
